import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import { APP_PREFIX_PATH, AUTHENTICATED_ENTRY } from "configs/AppConfig";
import { protectedRoutes, publicRoutes } from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";
import NotFound from "NotFound";
import PaymentSuccessReceipt from "views/app-views/PaymentDetails/PaymentSuccessReceipt";
import PaymentDetailPage from "views/app-views/PaymentDetailPage/PaymentDetailPage";

const Routes = () => {
  return (
    <RouterRoutes>
      <Route path={`${APP_PREFIX_PATH}/paymentdetails/receipt`} element={<PaymentSuccessReceipt />} />
      <Route path={`${APP_PREFIX_PATH}/paymentdetails/receipt/:policy_id/:order_id`} element={<PaymentDetailPage />} />
      <Route path="/" element={<ProtectedRoute />}>
        <Route
          path="/"
          element={<Navigate replace to={AUTHENTICATED_ENTRY} />}
        />
        {protectedRoutes.map((route, index) => {
          return (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
        {/* <Route path="*" element={<Navigate replace to="/"  />} /> */}
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {publicRoutes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
      </Route>
    </RouterRoutes>
  );
};

export default Routes;
